import { z } from 'zod';

export const AddMessageSchema = z.object({
    name_en: z.string().min(1, 'name_en is required.'),
    name_ar: z.string().min(1, 'name_ar is required'),
    price: z.string().optional().default(''),
    is_active: z.boolean().optional().default(true),
    start_date: z.date().optional(),
    end_date: z.date().optional(),
    number_of_sessions: z.string().optional().default(''),
    days: z.array(z.string()).optional().default([]),
});

export type AddMessageFormValues = z.infer<typeof AddMessageSchema>;
